import React from "react";
import { isEmpty } from "lodash";
import { IconList } from "@/components/IconList";
import classNames from "classnames";
import { Icon_Facility } from "@/types/qr";
import { Icons } from "@/types/icons";
import { hasInitialFacilities } from "../../utils/resolveInitialFacilities";
import { InitPreviewFacilities } from "../InitPreviewFacilities";
import "./PreviewFacilitiesCard.scss";

export interface PreviewFacilitiesCardProps {
  /** Array de facilities para mostrar */
  facilities?: Icon_Facility[];
  /** Facilities de placeholder para el estado inicial de la preview */
  previewFacilities?: Icon_Facility[];
  /** Indica si la preview está en estado inicial */
  isInitialPreview?: boolean;
  /** Título de la sección */
  title?: string;
  /** Variante de contexto */
  variant?: "business" | "event";
  /** Clase CSS adicional */
  className?: string;
}

/**
 * Tarjeta consolidada para Facilities/Services usada en Business y Event previews
 * Estandariza la presentación de facilities con título y lista de íconos
 */
export function PreviewFacilitiesCard({
  facilities,
  previewFacilities,
  isInitialPreview = false,
  title,
  variant = "business",
  className,
}: PreviewFacilitiesCardProps) {
  const hasFacilities = Boolean(facilities && !isEmpty(facilities));
  const hasPreviewFacilities = hasInitialFacilities(previewFacilities);
  const shouldShowPlaceholders = Boolean(
    isInitialPreview && !hasFacilities && hasPreviewFacilities
  );

  if (!hasFacilities && !shouldShowPlaceholders) {
    return null;
  }

  const cardClasses = classNames(
    "u-card",
    "preview-facilities-card",
    `preview-facilities-card--${variant}`,
    className
  );

  return (
    <div className={cardClasses}>
      {title && (
        <IconList
          iconItem
          items={{
            icon: Icons.circleStar,
            title,
          }}
          tag="h6"
          semibold
        />
      )}
      <div className="preview-facilities-card__icons">
        {shouldShowPlaceholders ? (
          <InitPreviewFacilities previewFacilities={previewFacilities} />
        ) : (
          <IconList
            isFacility
            items={facilities as unknown as string[]}
          />
        )}
      </div>
    </div>
  );
}
